<section *ngIf="banner" class="container front-page-banner">
  <advertisement [definition]="banner"></advertisement>
</section>
